/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Observable } from 'rxjs';

import {
  AssetCreateCandidatureTenantDto,
  AssetDto,
  AssetStatus,
  CreateAssetDto
} from './asset.model';
import { DocumentRequiredSnapshotDTO } from './document.model';
import {
  Conditioning,
  Incidence,
  OccupationEnum,
  ProfDataDto,
  Score,
  TenantCertification,
  User,
  UserDto
} from './users.model';

export class ShareProfileDto {
  asset: CreateAssetDto;
  email: string;
}

export class CreateCandidatureDto {
  user?: UserCreateCandidatureDto[];
  asset?: AssetCreateCandidatureTenantDto;
}

export class UserRequestCreateCandidatureDto {
  user?: UserCreateCandidatureDto;
}

export class UserRequestCreateMultipleCandidatureDto {
  users?: UserCreateCandidatureDto[];
}

export class UserCreateCandidatureDto {
  id?: string;
  birthDate: Date;
  dni: string;
  email: string;
  firstname: string;
  phone: string;
  surname1: string;
  surname2: string;
  postalCode: string;
  score?: Score;
  guarantor?: boolean;
  student?: boolean;
  freelance?: boolean;
  professionalData?: ProfDataDto;
  retired?: boolean;
  business?: boolean;
  businessName?: string;
  cif?: string;
  taxResidence?: string;
  coTenants?: string[];
  unremovable?: boolean;
  foreignIncomes?: boolean;

  fullName(): string {
    let fullName = this.firstname + ' ' + this.surname1;
    if (this.surname2) {
      fullName += ' ' + this.surname2;
    }
    return fullName;
  }
}

export class Candidature {
  id?: string;
  asset?: AssetDto;
  asset$?: Observable<AssetDto>;
  candidatureStatusEnum: CandidatureStatusEnum;
  expirationDate: Date;
  homeowner: HomeOwner;
  tenantCandidatureList: TenantCandidature[];
  score?: number;
  draftScore?: number;
  originalScore?: number;
  policyNumber?: string;
  policyContractedDate?: string;
  tenantPolicyNumber?: string;
  tenantPolicyContractedDate?: Date;
  latestUpdate?: Date;
  blockPolicy?: boolean;
  warrantyId?: string;
  closingForced?: boolean;
  certificationPaid?: boolean;
  paidDate?: Date;
  certifier?: string;
  selectDate?: Date;
  rejectDate?: Date;
  creationDate?: Date;
  thirdParty: boolean;
  archived?: boolean;
  isCandidatureSelectAndExpired?: boolean;
  comercialNotes?: ComercialNote[];
}

export interface HomeOwner {
  user: UserCreateCandidatureDto;
  userCandidatureStatusDtoEnum: any;
  insuranceCompanyCode?: string;
}
export class TenantCandidature {
  id?: string;
  analysisId?: string;
  user?: User;
  percentage?: number;
  status?: UserAnalysisStatusEnum;
  userCandidatureStatusDtoEnum?: any;
  requestAnalysisId?: string;
  requestAnalysisDate?: Date;
  incidences?: Incidence[];
  requestDocumentation?: RequestDocumentation;
  lastPayslipAmount?: string;
  pensionerTotalAmount?: string;
  Conditioning?: Conditioning;
  pendingToDownload?: boolean;
  duplicated?: boolean;
  hasInvoicePaymentConfirmation?: boolean;
  hasInvoiceRecordBook?: boolean;
  snapshot?: DocumentRequiredSnapshotDTO[];
  professionalData?: ProfDataDto;
}

export interface CandidatureDto {
  id: string;
  asset: AssetDto;
  asset$?: Observable<AssetDto>;
  tenantCandidatureList: any[];
  homeowner: any;
  candidatureStatusEnum: string;
  expirationDate: Date;
  itm: any;
}

export interface CandidatureIdDto {
  candidatureId: string;
}

export interface RequestDocumentation {
  id: string;
  tenantId: string;
  creationDate: Date;
}

export enum CandidatureStatusEnum {
  WITHOUT_CHECKING = 'WITHOUT_CHECKING',
  PENDING = 'PENDING',
  PRE_SELECT = 'PRE_SELECT',
  REJECT = 'REJECT',
  SELECT = 'SELECT',
  EXPIRED = 'EXPIRED'
}

export enum CandidatureStatusModalEnum {
  PENDING = 'pending',
  DOCUMENTS = 'documents',
  REVISION = 'revision',
  REVISION_EBI = 'revision-ebi',
  SELECTED = 'selected'
}

export enum UserAnalysisStatusEnum {
  WITHOUT_ANALYSIS = 0,
  IN_PROCESS_ANALYSIS = 1,
  REPORTED_ANALYSIS = 2
}

export interface ScoreResponseDto {
  date: Date;
  value: number;
  error: string;
}

export interface ValidateUserDto {
  dni: string;
  firstname: string;
  surname1: string;
  surname2: string;
  score?: ScoreResponseDto;
  guarantor?: boolean;
  occupation?: OccupationEnum;
  email?: string;
  student?: boolean;
  retired?: boolean;
  freelance?: boolean;
  business?: boolean;
  businessName?: string;
  cif?: string;
  taxResidence?: string;
  acceptTerms?: boolean;
  noValidated?: boolean;
}

export class TrialCandidatureRequestDto {
  asset: AssetDto;
  warrantyId: string;
  portfolioId?: string;
  users: ValidateUserDto[];
}

export interface ChangeUserRoleDto {
  candidatureId: string;
  tenantId: string;
  newRol: UserRole;
  businessName?: string;
  cif?: string;
  taxResidence?: string;
}

export enum UserRole {
  WORKER = 'WORKER',
  STUDENT = 'STUDENT',
  FREELANCE = 'FREELANCE',
  RETIRED = 'RETIRED',
  BUSINESS = 'BUSINESS',
  FOREIGN_INCOMES = 'FOREIGN_INCOMES'
}

export enum UserGuarantorRole {
  WORKER = 'WORKER',
  FREELANCE = 'FREELANCE',
  RETIRED = 'RETIRED'
}

export interface TenantInfoCandidature {
  tenant: User;
  assetId: string;
}

export interface ReSendEmailDto {
  asset: AssetDto;
  userTenant: User;
}

export class ChangeTenantEmailObj {
  email: string;
  newTenantEmail: string;
  candidatureId: string;
}

export class TenantCertificationDTO {
  user: TenantCertification;
}

export class Certification {
  id?: string;
  asset?: CreateAssetDto;
  users: TenantCertification[];
  warrantyId: string;
  certifier: string;
  apiUser: UserDto;
  tenantCandidatureList?: TenantCertificationDTO[];
  originalWarrantyId?: string;
}

export interface MoveCandidatureRequest {
  originCandidatureId: string;
  tenantList: TenantCandidature[];
  destinationAssetId: string;
}

export interface BrokerDto {
  insuranceCode: string;
  canContractTenantInsurances: boolean;
  insuranceBrokerPaid: boolean;
  tenantInsuranceCode?: string;
}

export interface UpdateUserStatusResponseDto {
  convertToGuarantor: boolean;
}

export interface ComercialNote {
  date: Date;
  message: string;
  userId: string;
}

export interface CandidaturesPageState {
  return?: boolean;
  moveCandidature?: boolean;
}

export interface CandidatureStats {
  candidatureId: string;
  rentalPrice: number;
  rentalPriceGroup: string;
  incomes: number;
  withGuarantor: boolean;
  withInsuranceUnpaid: boolean;
  withInsuranceRC: boolean;
  tenants: number;
  score: number;
  scoreGroup: string;
  effort: string;
  effortWithoutGuarantor: string;
  email: string;
  isInvoiced: boolean;
  year: number;
  month: number;
  deliveryDate: string;
  status: AssetStatus;
  effortNumber: number;
  effortWithoutGuarantorNumber: number;
  requestDate: string;
  groupTimeOperative: string;
  startHour: number;
  endHour: number;
  incidents: number;
  incomesWithoutGuarantors: number;
  time: number;
  timeOperative: number;
  startWeekDay: string;
  endWeekDay: string;
  address: string;
  assetId: string;
  buildingId: string;
  candidatureStatusEnum: CandidatureStatusEnum;
  door: string;
  floor: string;
  homeownerUserEmail: string;
  homeownerUserId: string;
  homeownerReference: string;
  latitude: string;
  longitude: string;
  number: string;
  policyHolderDataCcc: string;
  policyHolderDataCity: string;
  policyHolderDataDocument: string;
  policyHolderDataSurname1: string;
  portal: string;
  portfolioId: string;
  postalCode: string;
  province: string;
  selectDate: string;
  street: string;
  tenantDniList: string;
  tenantEmailList: string;
  tenantPolicyNumber: string;
  tenantPolicyContractedDate: string;
  policyNumber: string;
  policyContractedDate: string;
  trialVersion: boolean;
  userType: string;
  warrantyId: string;
  guarantorIDs: string;
  internalCodeBuilding: string;
}

export interface PolicyFilterRequest {
  policyNumber: string | null;
  portfolioId: string | null;
  buildingId: string | null;
  fromDate: string | null;
  toDate: string | null;
  policyHolderEmail: string | null;
}
